<template>
  <h3 class="SectionHeader">
    <span>{{ label }}</span>
  </h3>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    label: {
      type: String,
      required: true
    }
  }
} 
</script>

<style lang="scss">
  .SectionHeader {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0;
    font-family: $font_nav;
    font-size: 16px;
    color: $antraciet_blauw; // #D0D1D5;
    letter-spacing: 0.35px;
    margin: 16px 0;

    span {
      margin: 0 8px;

      &:first-letter {
        text-transform: capitalize;
      }
    }
    &:before, &:after {
      content: '';
      top: 1px;
      height: 1px;
      width: auto;
      background: $antraciet_blauw_medium; // #D0D1D5;
    }
    &:before {
      flex-grow: 1;
    }
    &:after {
      width: 32px;
    }
  }
</style>
